import { configureStore } from '@reduxjs/toolkit';
import authStore from './auth';
// import themeStore from "./theme";
import vendorIDReducer from './VendorIDSlice'; // The vendor ID slice

import favoritesReducer from './favoritesSlice';
import cartReducer from './cartSlice'; // Updated import
import stockReducer from './stockSlice';
import quantityReducer from './quantitySlice';
import cartAndAmountSlice from './cartAndAmountSlice';
import checkoutReducer from './checkoutSlice'; // Import the new checkout slice
import shippingAddressSlice from './shippingAddressSlice';
const store = configureStore({
  reducer: {
    loging: authStore.reducer,
    // mode: themeStore.reducer,
    cart: cartReducer,
    favorites: favoritesReducer,
    vendorID: vendorIDReducer,
    stock: stockReducer,
    quantities: quantityReducer, // Add this line
    cartAndAmount: cartAndAmountSlice,
    checkout: checkoutReducer, // Add the checkout reducer
    shippingAddress: shippingAddressSlice,
  },
});

export default store;
